<script lang="ts">
    import Logo from "./Logo.svelte";
</script>
<nav class="top" role='navigation'>
    <a href="https://www.unep.org"><Logo color="blue" /></a>
</nav>